import api from 'api';

export const getPartners = api('GET /api/bulk-upload/fields/partners');

export const uploadFile = async ({ file, partner }) => {
  return await api(`POST /api/bulk-upload/${partner}/upload`)(file);
};

export const loadTemplate = async ({ partner }) =>
  api(`GET /api/bulk-upload/${partner}/template`)();

export const checkStatus = api(`GET /api/bulk-upload/:partner/status`);
export const loadDictionary = api(`GET /api/bulk-upload/:partner/dictionary`);
